// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class CpcOrganizationunitVm {
    @AutoMap() ouId: string;
    @AutoMap() ouShortName: string;
    @AutoMap() ouLongName: string;
}
